import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { OptionsQuestionEntry } from '@entscheidungsnavi/api-types';
import { MatFormField, MatLabel } from '@angular/material/form-field';
import { MatOption, MatSelect } from '@angular/material/select';
import { ReactiveFormsModule } from '@angular/forms';
import { MatRadioButton, MatRadioGroup } from '@angular/material/radio';
import { FORWARD_CONTROL_CONTAINER } from '../../../form-elements';

@Component({
  selector: 'dt-questionnaire-question-options',
  templateUrl: './questionnaire-options.component.html',
  styleUrls: ['./questionnaire-options.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  viewProviders: [FORWARD_CONTROL_CONTAINER],
  imports: [MatFormField, MatLabel, MatSelect, MatOption, ReactiveFormsModule, MatRadioGroup, MatRadioButton],
})
export class QuestionnaireQuestionOptionsComponent {
  @Input()
  entry: OptionsQuestionEntry;

  @Input()
  formIndex: number;
}
